import React from 'react';
import {
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Edit, Trash2 } from 'lucide-react';
import { Subsubtype } from '../../types/ServiceAccordion.type';
import { treeItemSx } from '../common/TreeBranch';

interface ServiceSubSubtypeCardProps {
  subsubtype: Subsubtype;
  onEdit: (subsubtype: Subsubtype) => void;
  onDelete: (subsubtype: Subsubtype) => void;
}

const ServiceSubSubtypeCard: React.FC<ServiceSubSubtypeCardProps> = ({
  subsubtype,
  onEdit,
  onDelete,
}) => {
  return (
    <ListItem
      disablePadding
      secondaryAction={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            edge="end"
            aria-label="edit"
            onClick={() => onEdit(subsubtype)}
            sx={{ ml: 1 }}
          >
            <Edit size={14} />
          </IconButton>
          <IconButton
            edge="end"
            aria-label="delete"
            onClick={() => onDelete(subsubtype)}
            sx={{ ml: 1 }}
          >
            <Trash2 size={14} />
          </IconButton>
        </Box>
      }
      sx={[
        {
          mb: 1,
          py: 1,
          px: 2,
          backgroundColor: 'background.paper',
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        },
        treeItemSx,
      ]}
    >
      <ListItemText
        primary={
          <Typography variant="body2" component="div" fontWeight="medium">
            {subsubtype.name}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default ServiceSubSubtypeCard;
